import { useDispatch, useSelector } from "react-redux"
import TagBox from "./TagBox";

// conveyor, project, structure, tower 각각 있어야 하는 이유인가?? 
import { changeField } from "../../modules/conveyor/conveyorWriteSlice";


const TagBoxContainer = () => {
    const dispatch = useDispatch();
    const { tags } = useSelector(({ conveyorWrite }) => ({
        tags: conveyorWrite.tags,
    }));

    const language = useSelector((state) => state.language.language);


    const onChangeTags = nextTags => {
        dispatch(
            changeField({
                key: 'tags',
                value: nextTags,
            })
        );
    };

    return (
        <TagBox onChangeTags={onChangeTags} tags={tags} language={language} />
    );
};

export default TagBoxContainer;